import { createStyles } from '@mantine/core';
import type { PropsWithChildren } from 'react';

import useHeaderHeight from '~/domains/common/components/AppShellHeaderRoot/useHeaderHeight';
import dt from '~/testing';

const useStyles = createStyles((theme, { headerHeight }: { headerHeight?: number } = {}) => ({
  main: {
    height: '100%',
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
    display: 'flex',
    flexDirection: 'column',
  },
  subHeader: {
    width: '100%',
    background: theme.colors.dark[6],
    [theme.fn.smallerThan('sm')]: {
      minHeight: 50,
    },
  },
  tabs: {
    minHeight: 39,
    width: '100%',
    background: theme.colors.dark[6],
    position: 'sticky',
    zIndex: 9,
    top: headerHeight,
    left: 0,
    marginBottom: theme.spacing.xl,
  },
  layout: {
    paddingLeft: theme.other.layout.paddingLg,
    paddingRight: theme.other.layout.paddingLg,
    [theme.fn.smallerThan('lg')]: {
      paddingLeft: theme.other.layout.paddingMd,
      paddingRight: theme.other.layout.paddingMd,
    },
    [theme.fn.smallerThan('md')]: {
      paddingLeft: theme.other.layout.paddingSm,
      paddingRight: theme.other.layout.paddingSm,
    },
    maxWidth: theme.other.layout.maxWidth,
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: theme.other.spacing._24,
  },
}));

function MyLayoutTabs({ children }: PropsWithChildren) {
  const headerHeight = useHeaderHeight();

  const { classes } = useStyles({ headerHeight });
  return (
    <div className={classes.tabs} data-test-id={dt.myContests.layout.header.tabs.main}>
      <div className={classes.layout}>{children}</div>
    </div>
  );
}

function MyLayoutContent({ children }: PropsWithChildren) {
  const { classes } = useStyles({});
  return (
    <div className={classes.layout} data-test-id={dt.myContests.layout.content.main}>
      {children}
    </div>
  );
}

function MyLayout({ children }: PropsWithChildren) {
  const { classes } = useStyles({});
  return (
    <section className={classes.main} data-test-id={dt.myContests.layout.main}>
      {children}
    </section>
  );
}

MyLayout.Content = MyLayoutContent;
MyLayout.Tabs = MyLayoutTabs;

export default MyLayout;
